import { getScrollTop } from './getScrollTop';

export function scrollToPos(to: number, duration: number = 0): Promise<void> {
  if (!window.requestAnimationFrame || !duration) {
    window.scrollTo(0, Math.round(to));

    return Promise.resolve();
  }

  const startTime = Date.now();
  const from = getScrollTop();

  return new Promise<void>(resolve => {
    const step = () => {
      const time = Date.now();
      let elapsed = (time - startTime) / duration;

      elapsed = elapsed > 1 ? 1 : elapsed;

      const value = 0.5 * (1 - Math.cos(Math.PI * elapsed));

      const currentPos = from + (to - from) * value;

      window.scrollTo(0, currentPos);

      if (currentPos !== to) {
        window.requestAnimationFrame(step);
      } else {
        resolve();
      }
    };

    step();
  });
}
